import React from 'react';
import Slider from 'react-slick';
import iPro from "../img/envision/casestudies/casestudieslogo/fordlogo-removebg-preview.png";
import aCad from "../img/envision/casestudies/casestudieslogo/hirotechlogo-removebg-preview.png";
import nMan from "../img/envision/casestudies/casestudieslogo/itclogo-removebg-preview.png";
import Kuka from "../img/envision/casestudies/casestudieslogo/tatamoterslogo-removebg-preview.png";
import Abb from "../img/envision/casestudies/casestudieslogo/teslalogo-removebg-preview.png";

// Settings for the Slick slider
const sliderSettings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000, // Change to your preferred speed
    arrows: false, // Disable next and previous arrows
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
};

const Casestudiesindustries = () => {
    return (
        <div style={styles.pageContainer}>
            <div className="container mt-5 pb-5">
                <div className="row justify-content-center">
                    <div className="col-11">
                        {/* Heading aligned to the center */}
                        <h3 style={styles.heading}>
                          Industries
                        </h3>

                        {/* Slider component */}
                        <Slider {...sliderSettings}>
                            {/* Images in Slider */}
                            <div className="d-flex justify-content-center align-items-center" style={styles.imageContainer}>
                                <img src={iPro} alt="iPro" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="d-flex justify-content-center align-items-center" style={styles.imageContainer}>
                                <img src={aCad} alt="aCad" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="d-flex justify-content-center align-items-center" style={styles.imageContainer}>
                                <img src={nMan} alt="nMan" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="d-flex justify-content-center align-items-center" style={styles.imageContainer}>
                                <img src={Kuka} alt="Kuka" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="d-flex justify-content-center align-items-center" style={styles.imageContainer}>
                                <img src={Abb} alt="Abb" className="img-fluid" style={styles.image} />
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

// CSS-in-JS Styles
const styles = {
    pageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // height: '100vh', // Full viewport height
        backgroundColor: '#fff', // Light background for the page
    },
    heading: {
        fontSize: '35px',
        textAlign: 'center',
        marginBottom: '30px',
        color:"rgb(6 133 156)"
    },
    imageContainer: {
     display: 'flex',
     justifyContent: 'center',
     alignItems:' center',
     width:'120px',
     height:'120px',
     border: '2px solid rgb(213, 214, 221)',
    
    },
    image: {
        height: '120px', // Set image height
        backgroundColor: '#fff', // Background color
        border: '1px solid #000', // 2px solid yellow border
        margin: '0px 30px', // Horizontal margin for spacing
        width: '90%', // Set width
        borderRadius: '20px',
    },
};

const spanStyle = {
    subHeading: {
        color: 'orange',
    }
};

export default Casestudiesindustries;
